export default __webpack_public_path__ + "static/media/selamu.2eba099d.jpg";